import { CheckoutRoutes } from "./CheckoutRoutes";

export * from "./CheckoutRoutes";

export const standardCheckoutRoutes = new CheckoutRoutes();
export const trialCheckoutRoutes = new CheckoutRoutes({ isFreeTrial: true });
